import { Button } from '@material-ui/core';
import React from 'react';
import { SupplierType } from '../SupplierType';
import { useStyles } from './styles';
import { useEditFormContext } from 'pages/formsCreate/context';
import { ISupplierContact } from 'pages/formsCreate/types';

interface IProps {
  supplierType: string;
  handleSupplierTypes: (event: React.ChangeEvent<{ value: unknown }>) => void;
  suppliersData: ISupplierContact[];
}

export const CustomToolbar = ({ handleSupplierTypes, supplierType, suppliersData }: IProps) => {
  const styles = useStyles();
  const { selectedSuppliers, setSelectedSuppliers } = useEditFormContext();

  const handleSelectAll = () => {
    const ids: number[] = suppliersData.map(({ ID_PESSOA }) => Number(ID_PESSOA));
    if (selectedSuppliers.length) {
      setSelectedSuppliers([]);
    } else {
      setSelectedSuppliers(ids);
    }
  };

  return (
    <>
      <Button variant="contained" color="secondary" className={styles.button} onClick={handleSelectAll}>
        {selectedSuppliers.length ? 'Desmarcar seleções' : 'Selecionar todos os fornecedores'}
      </Button>
      <SupplierType handleSupplierTypes={handleSupplierTypes} supplierType={supplierType} />
    </>
  );
};
